import React from "react";
import underWater from "./underwater.png";
import { Link } from "react-router-dom";
import "./EnvHome.css";

function EnvHome() {
  return (
    <div>
      <div className="land-page">
        <div className="tc"></div>
        <img src={underWater} className="land-img" alt="aqua" />
        <div className="circle"></div>
        <div className="textb"></div>
      </div>
      <div className="opts-pg">
        <h1 className="title">Your Goals</h1>
        <div className="opts">
          <div className="option">
            <Link
              to="/bottlecoll"
              style={{ textDecoration: "none", color: "black" }}
            >
              <h2>Bottle Collector</h2>
              <img src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTnotJhAUGfiCnxfO3vTqy_LKrpejpI8maHWGOQNZPx3tZOa_S3hybR8mIvWBdgb1FWdqo&usqp=CAU" />
              <p>Collect plastic bottles. Earn points, rewards etc</p>
            </Link>
          </div>
          <div className="option">
            <Link
              to="/events"
              style={{ textDecoration: "none", color: "black" }}
            >
              <h2>Events</h2>
              <img src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTZlcPQpE9N2y2Uj_F3XD4JJ0u0_A6fFMcePg&usqp=CAU"/>
              <p>Know about the events happening around you.</p>
            </Link>
          </div>
          <div className="option">
            <Link
              to="/ecoproducts"
              style={{ textDecoration: "none", color: "black" }}
            >
              <h2>Eco Friendly products</h2>
              <img src="https://www.mcrsafety.com/~/media/mcrsafety/blog/2021/06---june/162214734642023982.png?h=327&w=318&hash=FAB2134EFE600B412D076024A47DA69B"/>
              <p>Support other companyies who have the same intention</p>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}

export default EnvHome;
